import { SearchTerm } from './SearchTerm';

const EventTypeSearch: SearchTerm[] = [
    {
        heading: "Type",
        accessor: "name",
        searchOnName: "trnName",
        translationKey: "type"
    }
];

export default EventTypeSearch;
